import React from 'react';

import PersonIcon from '@mui/icons-material/Person';
import SmartToyIcon from '@mui/icons-material/SmartToy';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

type Props = {
  role: 'ai' | 'human';
  children: React.ReactNode;
};

/**
 * チャットバブル（AI=青系、人間=緑系）
 */
const WorkflowChatBubble: React.FC<Props> = ({ role, children }) => {
  const isAi = role === 'ai';
  const color = isAi ? '#1565c0' : '#2e7d32';
  const bgColor = isAi ? 'rgba(21, 101, 192, 0.08)' : 'rgba(46, 125, 50, 0.08)';

  return (
    <Stack direction="row" spacing={1} alignItems="flex-start">
      <Box
        sx={{
          width: 28,
          height: 28,
          minWidth: 28,
          borderRadius: '50%',
          bgcolor: `${color}20`,
          color: color,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          mt: 0.25,
        }}
      >
        {isAi ? <SmartToyIcon sx={{ fontSize: 16 }} /> : <PersonIcon sx={{ fontSize: 16 }} />}
      </Box>
      <Box
        sx={{
          bgcolor: bgColor,
          borderRadius: 2,
          px: 2,
          py: 1,
          flex: 1,
          borderLeft: 3,
          borderColor: color,
        }}
      >
        <Typography variant="caption" fontWeight={600} sx={{ color, mb: 0.25, display: 'block' }}>
          {isAi ? 'AI (Kiro)' : 'Human'}
        </Typography>
        <Typography
          variant="body2"
          color="text.secondary"
          component="div"
          sx={{ whiteSpace: 'pre-line' }}
        >
          {children}
        </Typography>
      </Box>
    </Stack>
  );
};

export default WorkflowChatBubble;
